const vuetifyConfig = new Vuetify({
    icons: {
        iconfont: 'mdiSvg' // 'mdi' || 'mdiSvg' || 'md' || 'fa' || 'fa4' || 'faSvg'
    },
    theme: {
        themes: {
            light: {
                primary: '#005DA1',
                secondary: '#6596A7',
                menus: '#424242',
                accent: '#82B1FF',
                error: '#DA4D3D',
                info: '#1CB3CB',
                success: '#80BA27',
                warning: '#FFC107'
            }
        }
    }
})

class HttpStatus {
}

HttpStatus.SUCCESS = 200
HttpStatus.BAD_REQUEST = 400
HttpStatus.UNAUTHORIZED = 401
HttpStatus.FORBIDDEN = 403
HttpStatus.NOT_FOUND = 404
HttpStatus.INTERNAL_SERVER_ERROR = 500

class ContentType {
}

ContentType.URL_ENCODED = 'application/x-www-form-urlencoded'
ContentType.JSON = 'application/json'
ContentType.FORM_DATA = 'multipart/form-data'
ContentType.HTML = 'text/html'
ContentType.PDF = 'application/pdf'

class ResponseType {
}

ResponseType.BLOB = 'blob'
class NorseResponseTools {
    constructor(response) {
        this.response = response
    }

    getContentTypes() {
        return this.response.headers['content-type'] || []
    }

    isJSON() {
        return this.getContentTypes().includes(ContentType.JSON)
    }

    isHTML() {
        return this.getContentTypes().includes(ContentType.HTML)
    }

}

// Enhance axios response with custom functions under norseTools
axios.interceptors.response.use(response => {
        response.norseTools = new NorseResponseTools(response)
        return response
    }, error => {
        const response = error.response
        if (!!response) {
            response.norseTools = new NorseResponseTools(response)
        }

        throw error
    }
)

class NorseClientData {
    constructor(data) {
        this._checkType(data)
        this.data = data
        this._addedData = []
    }

    _checkType(data) {
        if (this._isHtmlFormElement(data) || this._isObject(data)) {
            return
        }
        throw TypeError('HTMLFormElement or Plain json is allowed')
    }


    addData(key, value) {
        this._addedData.push({[key]: value})
    }

    static getNorseClientData(data) {
        if (data instanceof NorseClientData) {
            return data
        }
        return new NorseClientData(data)
    }

    getFormData() {
        if (this._isHtmlFormElement(this.data)) {
            let formData = new FormData(this.data)
            let url = this.data.getAttribute('action')
            if (url) {
                formData.append('action_url', url)
            }
            return this._mergeData(formData, this._addedData)
        }

        if (this._isObject(this.data)) {
            let formData = new FormData()
            for (const key in this.data) {
                if (this._isArray(this.data[key])) {
                    this._addArray(formData, key, this.data[key])
                    continue
                }
                formData.append(key, this.data[key])
            }
            return this._mergeData(formData, this._addedData)
        }

    }

    _addArray(formData, key, data) {
        data.forEach(value => {
            formData.append(key, value)
        })
    }

    _mergeData(formData, added_data) {
        added_data.forEach(data => {
            Object.keys(data).forEach(key => {
                formData.append(key, data[key])
            })
        })
        return formData
    }

    _isArray(data){
        return data.constructor === Array
    }

    _isHtmlFormElement(data) {
        return data instanceof HTMLFormElement
    }

    _isObject(data) {
        return data && data.constructor === Object
    }

}

class NorseClient {
    constructor(url = '') {
        this.csrf_token = '{{ csrf_token }}'
        this.url = url

        this.errorHandler = this.genericErrorHandler
    }

    genericErrorHandler(error) {
        ErrorHandler.processError(error, HttpStatus.BAD_REQUEST)
    }

    setErrorHandler(errorHandler){
        this.errorHandler = errorHandler
    }

    get(data = {}) {
        let config = this.formConfig
        config['params'] = data
        let get = axios.get(this.url, config)

        let wrap = new Promise((outer_resolve) => {
            get.then((response) => {
                outer_resolve(response)
            }).catch((error) => {
                ErrorHandler.processError(error)
                EventBus.$emit('close-popup')
            })
        })
        return wrap
    }

    getNorseData(data, actionID) {
        let norseData = NorseClientData.getNorseClientData(data)
        norseData.addData('action', actionID)
        return norseData
    }

    getFormData(data) {
        if (data instanceof NorseClientData) {
            return data.getFormData()
        }
        let norseData = new NorseClientData(data)
        return norseData.getFormData()
    }

    post(data = {}, config = this.formConfig) {
        let formData = this.getFormData(data)
        if (!this.url) {
            this.url = formData.get('action_url') || ''
        }
        let post = axios
            .post(this.url, formData, config)
            .catch((error) => {
                throw resolveError(error)
            })

        return new Promise((outerResolve, outerReject) => {
            return post.then(outerResolve, this.errorHandler)
                .catch((error) => {
                    outerReject(error)
                })
        })
    }

    get formConfig() {
        return {
            'xsrfCookieName': 'brage-csrf',
            'xsrfHeaderName': 'X-CSRFTOKEN',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'X-Requested-With': 'XMLHttpRequest'
            }
        }
    }
}

class HTTPResponseError {
    constructor(response) {
        this.response = response
    }
}

class JSONBadRequestError extends HTTPResponseError {
    constructor(response) {
        super(response)

        this.message = 'Unhandled error'
        if (response.data.message) {
            this.message = response.data.message
        }
    }
}

class HTMLBadRequestError extends HTTPResponseError {
    constructor(response) {
        super(response)
        this.html_content = response.data
    }
}

function resolveError(error) {
    if (!error.response) {
        return error
    }

    const response = error.response
    if (response.status === HttpStatus.BAD_REQUEST) {

        if (response.norseTools.isHTML()) {
            return new HTMLBadRequestError(response)
        }

        if (response.norseTools.isJSON()) {
            return new JSONBadRequestError(response)
        }
    }

    return new HTTPResponseError(response)
}

class Action {
    constructor(actionID) {
        this.actionID = actionID
        this.client = new NorseClient()
        this.download = new Downloader(actionID, this.client)
    }

    performAction(data = {}) {
        let norseData = this.getNorseData(data)
        return this.client.post(norseData)
    }

    setErrorHandler(errorHandler) {
        this.client.setErrorHandler(errorHandler)
    }

    enableManualCatch() {
        let handler = (error) => {
            throw error
        }
        this.setErrorHandler(handler)
    }

    getNorseData(data) {
        let norseData = this._getNorseClientData(data)
        norseData.addData('action', this.actionID)
        return norseData
    }

    _getNorseClientData(data) {
        if (data instanceof NorseClientData) {
            return data
        }
        return new NorseClientData(data)
    }
}

class Downloader {
    constructor(actionID, client) {
        this.actionID = actionID
        this.client = client
    }

    pdf(data = {}, app = {}) {
        let contentType = ContentType.PDF

        let norseData = this.client.getNorseData(data, this.actionID)
        let config = new NorseClient().formConfig
        config['responseType'] = ResponseType.BLOB
        return this.client.post(norseData, config).then((response) => {
            return new Promise((outerResolve) => {
                const report = new Blob([response.data], {type: contentType})
                let link = document.createElement('a')
                link.href = window.URL.createObjectURL(report)
                const regExpFilename = /filename="(?<filename>.+)\.(.+)"/
                const filename = regExpFilename.exec(response.headers['content-disposition'])?.groups?.filename ?? null
                link.download = filename || 'prov'
                link.click()
                window.URL.revokeObjectURL(link.href)
                return outerResolve(response)
            })
        })
    }
}

class PopupAction extends Action {
    performAction(data = {}) {
        let norseData = this.getNorseData(data)
        return new NorseClient().post(norseData).catch((error) => {
            if (error instanceof HTMLBadRequestError) {
                EventBus.$emit('render-popup', error.response.data)
                return
            }
            EventBus.$emit('close-popup')
            throw error
        })
    }
}

class LoadJSAction extends Action {
    performAction(data = {}) {
        let norseData = this.getNorseData(data)
        return new NorseClient().post(norseData).then(response => {
            if (response.data && response.data.js) {
                let script = this._addJavascript(response.data.js)
                document.getElementsByTagName('body')[0].append(script)
            }
            return response
        })
    }

    _addJavascript(data) {
        let reset_vue = `if (dynamic_vue instanceof Vue) {
            dynamic_vue.$destroy()
        }`
        var script = document.createElement('script')
        script.type = 'text/javascript'
        script.innerHTML = `${reset_vue} ${data}`
        script.async = false
        return script
    }
}

class InlineEditAction {
    constructor(actionID) {
        this._action = new Action(actionID)
    }

    performAction(fieldName, fieldData) {
        let postData = {
            [fieldName]: fieldData
        }
        return this._action.performAction(postData).catch((error) => {
            if (error instanceof HTMLBadRequestError) {
                ErrorHandler.processError(error)
                return
            }
            throw error
        })
    }
}

const EventBus = new Vue()

class Constants {
}

Constants.DATE_FORMAT = 'YYYY-MM-DD'
Constants.WEEKDAYS_DEFAULT = [1, 2, 3, 4, 5, 6, 0]
Constants.STATE_COLOR_MAP = {
    1: 'secondary',
    2: 'warning',
    3: 'info',
    4: 'success'
}
Constants.VERDICTS_STATES = {
    ok: 1,
    notOk: 2,
    notPresent: 3,
    notHandedIn: 4
}

class ErrorHandler {
    static processError(error, ignore_status) {
        if (error instanceof JSONBadRequestError) {
            app.showErrorMessage(error.message)
            return
        }

        if (error.response) {
            // The request was made and the server responded with a status code
            // that falls out of the range of 2xx
            // console.log(error.response.data);
            // console.log(error.response.status);
            if (ignore_status && error.response.status === ignore_status) {
                return
            }
            let msg = this._resolveMsg(error.response)
            app.showErrorMessage(msg)
            return
        }
        if (error.request) {
            // The request was made but no response was received
            // `error.request` is an instance of XMLHttpRequest

            app.showErrorMessage('Unhandled error')
            console.log('ERROR:', error)
            return
        }
        if (error instanceof PromiseRejectionEvent) {
            if (error.reason) {
                if (error.reason.response) {
                    let msg = this._resolveMsg(error.reason.response)
                    app.showErrorMessage(msg + ', unhandled')
                    return
                }
                app.showErrorMessage(error.reason + ' (unhandled)')
                return
            }
        }
        // Something happened in setting up the request that triggered an Error
        app.showErrorMessage(error)
    }

    static _resolveMsg(response) {
        console.log('resolve msg', response)
        let msg = ''
        if (response.data) {
            if (response.data.message) {
                msg = response.data.message + ', ' + response.statusText + ' (' + response.status + ')'
                return msg
            }
            msg = '"' + response.data.substring(0, 32) + '", '
        }
        msg = msg + response.statusText + ' (' + response.status + ')'
        return msg
    }
}

class ComponentUpdate {
    static updateInputComponent(fieldName, value) {
        EventBus.$emit(`update-input-${fieldName}`, {'newValue': value})
    }
}

class NorseVue {
    constructor(options = {}) {
        this.data = options.data || {}
        this.components = options.components || {}
        this.computed = options.computed || {}
        this.methods = options.methods || {}
        this.directives = options.directives || {}
        this.watch = options.watch || {}
        this.mounted = options.mounted || function () {}
        this.created = options.created || function () {}
    }

    extend(options) {
        Object.assign(this.data, options.data || {})
        Object.assign(this.components, options.components || {})
        Object.assign(this.computed, options.computed || {})
        Object.assign(this.methods, options.methods || {})
        Object.assign(this.directives, options.directives || {})
        Object.assign(this.watch, options.watch || {})
        let createdFunc = this.created
        this.created = function () {
            createdFunc.call(this)
            options.created && options.created()
        }
        let mountedFunc = this.mounted
        this.mounted = function () {
            mountedFunc.call(this)
            options.mounted && options.mounted()
        }
    }
}

let extend_vue = new NorseVue()

class KeyCodes {
}

KeyCodes.TAB = 9
KeyCodes.ENTER = 13
KeyCodes.CTRL = 17
KeyCodes.SHIFT = 16
KeyCodes.ESCAPE = 27

Vue.directive('initial-value', {
    bind(el, binding, vnode) {
        //Writes data _from_ an input field
        //_to_ the "v-model"
        if (!vnode.data.model) {
            return
        }
        Vue.nextTick(() => {
            let key = vnode.data.model.expression
            if (key) {
                if (vnode.context[key] && vnode.context[key].constructor === Array) {
                    if (binding.value.constructor === Array) {
                        vnode.context[key].push(...binding.value)
                        return
                    }
                    vnode.context[key].push(binding.value)
                    return
                }
                vnode.context[key] = binding.value
            }
        })
    }
})

// initializes data properties directly on the component context
Vue.directive('set-properties', {
    bind(el, binding, vnode) {
        for (let key in binding.value) {
            let param = vnode.context[key]
            let value = binding.value[key]
            if (Array.isArray(param) && !Array.isArray(value)) {
                param.push(value)
                continue
            }
            vnode.context[key] = binding.value[key]
        }
    }
})

// initializes data properties directly on the component context
Vue.directive('set-compound-properties', {
    bind(el, binding, vnode) {
        for (let key in binding.value) {
            if (key !== 'key') {
                let contextKey = binding.value['key']
                if (!Array.isArray((vnode.context[key]))) {
                    throw new Error(`Parameter ${key} must be an array!`)
                }
                vnode.context[key][contextKey] = binding.value[key]
            }
        }
    }
})

// fires a certain event on enter key
Vue.directive('enter-key-handler', {
    bind(el, binding, vnode) {
        el.addEventListener('keyup', function (e) {
            if (e.keyCode === KeyCodes.ENTER) {
                binding.value && binding.value()
            }
        })
    }
})

Vue.component('table-component', {
    delimiters: ['[[', ']]'],
    props: {
        headers: {
            type: Array,
            default: true
        },
        rows: {
            type: Array,
            required: true
        }
    },
    template:
        `<v-simple-table fixed-header>
            <template v-slot:default>
                <thead>
                    <tr>
                        <th class="text-left" v-for="(header, index) in headers" :key="index">[[ header ]]</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(row, rowIndex) in rows" :key="rowIndex">
                        <td v-for="(col, colIndex) in row" :key="colIndex">
                            <component v-if="hasHTML(col)" :is="{ template: col }"></component>
                            <template v-else>[[ col ]]</template>
                        </td>
                    </tr>
                </tbody>
            </template>
        </v-simple-table>`,
    methods: {
        hasHTML (str) {
            let pattern = new RegExp(/<\/?[a-z][\s\S]*>/i)
            return pattern.test(str)
        }
    }
})

Vue.component('popup-component', {
    data() {
        return {
            dialog: false,
            content: null,
            actions: {},
            contentData: {}
        }
    },
    props: {
        id: {
            type: String,
            default: ''
        },
        width: {
            default: 500
        }
    },
    template:
        `<v-dialog v-model="dialog" :max-width="width">
            <v-card class="py-1">
                <!-- Title of modal -->
                <slot name="title"></slot>
                <!-- Content of modal -->
                <component :is="content"></component>
                <slot></slot>
            </v-card>
        </v-dialog>`,
    methods: {
        renderContent(contentHtml) {
            this.$nextTick(() => {
                let data = this.contentData
                this.content = {
                    template: contentHtml,
                    data() { return data },
                    methods: {
                        closePopup: this.closePopup,
                        ...this.actions
                    }
                }
            })
        },
        openPopup(params) {
            if (params) {
                this.actions = params.actions || {}
                this.contentData = params.data || {}
                this.renderContent(params.content)
            }
            this.dialog = true
        },
        closePopup() {
            this.dialog = false
        }
    },
    created() {
        let id = this.id ? `-${this.id}` : ''
        EventBus.$on(`open-popup${id}`, this.openPopup)
        EventBus.$on(`close-popup${id}`, this.closePopup)
        EventBus.$on(`render-popup${id}`, this.renderContent)
    }
})

let dynamic_vue = null

Vue.component('popup-js-component', {
    data() {
        return {
            dialog: false,
            content: null,
            actions: {},
            contentData: {}
        }
    },
    props: {
        id: {
            type: String,
            required: true
        },
        width: {
            default: 500
        }
    },
    template:
        `<v-dialog v-model="dialog" :max-width="width">
            <v-card class="py-1">
                <!-- Title -->
                <v-card-title>
                    <slot name="title"></slot>
                </v-card-title>     
                <!-- Content -->
                <v-card-text class="py-0">
                    <div :id="popupId"><div></div></div>
                </v-card-text>
                <!-- Actions -->
                <v-card-actions class="mx-3">
                    <slot name="actions"></slot>
                </v-card-actions>
                <!-- General -->
                <div :id="popupId"><div></div></div>
            </v-card>
        </v-dialog>`,
    computed: {
        popupId() {
            return `popup-content-${this.id}`
        }
    },
    methods: {
        renderContent(contentHtml) {
            this.$nextTick(() => {
                this.$nextTick(() => {
                    if (!dynamic_vue || !(dynamic_vue instanceof Vue)) {
                        throw new Error('The dynamically loaded script muse be a Vue instance!')
                    }
                    dynamic_vue.$options.template = contentHtml
                    dynamic_vue.$mount(`#popup-content-${this.id} > div`)
                })

            })
        },
        openPopup(contentHtml) {
            if (contentHtml) {
                this.renderContent(contentHtml)
            }
            this.dialog = true
        },
        closePopup() {
            this.dialog = false
        }
    },
    created() {
        let id = this.id ? `-${this.id}` : ''
        EventBus.$on(`open-popup${id}`, this.openPopup)
        EventBus.$on(`close-popup${id}`, this.closePopup)
        EventBus.$on(`render-popup${id}`, this.renderContent)
    }
})

const TemplateComponent = Vue.component('template-component', {
    data() {
        return {
            content: null,
            actions: {},
            computed: {},
            directives: {},
            evaluated: {},
            contentData: {}
        }
    },
    props: {
        id: {
            type: String,
            default: ''
        },
    },
    template:
        `<component :is="content"></component>`,
    methods: {
        renderContent(contentHtml) {
            let data = this.contentData
            this.content = {
                template: contentHtml,
                data() {
                    return data
                },
                computed: {
                    ...this.computed
                },
                methods: {
                    ...this.actions
                },
                directives: {
                    ...this.directives
                },
            }
            this.$nextTick(() => {
                let id = this.id ? `-${this.id}` : ''
                EventBus.$emit(`template-rendered${id}`)
            })
        },
        createTemplate(params) {
            if (params) {
                this.actions = params.actions || {}
                this.computed = params.computed || {}
                this.directives = params.directives || {}
                this.contentData = params.data || {}
                this.evaluated = params.evaluated || {}
                this.renderContent(params.content)
            }
        }
    },
    created() {
        let id = this.id ? `-${this.id}` : ''
        EventBus.$on(`create-template${id}`, this.createTemplate)
        EventBus.$on(`render-template${id}`, this.renderContent)
    }
})

const FormComponent = TemplateComponent.extend()

Vue.component('form-component', FormComponent)


Vue.component('dropdown-menu-component', {
    props: {
        primary: {
            type: Boolean,
            default: false
        }
    },
    template:
`        <v-menu left bottom :nudge-bottom="20" nudge-left="20">
            <template v-slot:activator="{ on }">
                <v-btn icon v-on="on" width="36px" height="36px" color="primary" :outlined="primary">
                    <v-icon>mdi-dots-vertical</v-icon>
                </v-btn>
            </template>
            <slot></slot>
        </v-menu>`
})

Vue.component('link-component', {
    delimiters: ['[[', ']]'],
    props: {
        path: {
            type: String,
            required: true
        }
    },
    template:
        `<div class="link-multiline" @click="redirect(path)">
            <slot></slot>
            <v-icon class="arrow-icon">mdi-arrow-right</v-icon>
        </div>`,
    methods: {
        redirect(url) {
            window.location = url
        }
    }
})

const InlineEditComponent = Vue.component('inline-edit-component', {
    data() {
        return {
            show: false,
            displayValue: this.defaultValue,
            _defaultValue: this.defaultValue,
            isChanged: false,
            exceptionList: []
        }
    },
    props: {
        name: {
            required: true
        },
        defaultValue: {
            type: String,
            required: true
        },
        label: {
            type: String,
            required: true
        },
        enabled: {
            type: String,
            default: ''
        },
        emitUpdateEvent: {
            type: Boolean,
            default: false
        }
    },
    template:
        `<div v-if="enabled" v-enter-key-handler="saveHandler">
            <div class="link-edit pa-3" @click="showEditMode" v-on-clickaway="cancelEdit">
                <div>
                    <strong>{{ label }}</strong>
                    <v-btn icon @click.stop="toggleEditMode">
                        <v-icon>mdi-pencil</v-icon>
                    </v-btn>
                </div>
                <div v-if="show" ref="slot" class="mt-3">
                    <slot :parent="this"></slot>
                </div>
                <div v-else>{{ displayValue }}</div>
            </div>
        </div>
        <div v-else>
            <slot :parent="this"></slot>
        </div>`,
    computed: {
        inputValue: {
            get() {
                if (this.isChanged) {
                    return this.displayValue
                }

                return this._defaultValue
            },
            set(newValue) {
                this.isChanged = true
                this.displayValue = newValue
                if (this.emitUpdateEvent) {
                    EventBus.$emit('input-updated', {'name': this.name, 'value': newValue})
                }
            }
        }
    },
    methods: {
        toggleEditMode() {
            if (!this.show) {
                this.showEditMode()
                return
            }
            this.cancelEdit()
        },
        isHidden() {
            return !this.show
        },
        showEditMode() {
            this.show = true
            this.$nextTick(() => {
                this.setActiveInput()
            })
        },
        hideEditMode() {
            this.show = false
        },
        cancelEdit(event) {
            if (this.isHidden()) {
                return
            }

            if (event) {
                let path = event.path || (event.composedPath && event.composedPath())
                let isException = path.some(item => {
                    return item.className && this.exceptionList.some(exception => {
                        let classNames = item.className.split(' ')
                        return classNames.includes(exception)
                    })
                })
                if (isException) {
                    return
                }
            }
            this.hideEditMode()
            this.resetInputValue()
        },
        resetInputValue() {
            this.inputValue = this._defaultValue
        },
        setActiveInput() {
            let input = this.$refs.slot.querySelector(`input`)
            input.focus()
            let btnOk = this.$refs.slot.querySelector('.btn-ok')
            btnOk && btnOk.addEventListener('click', this.saveHandler)
        },
        saveHandler(event) {
            event && event.stopPropagation()
            EventBus.$emit('inline-edit-commit', {'name': this.name, 'value': this.inputValue})
            this.hideEditMode()
        },
        updateValue(params) {
            this.displayValue = params.newValue || this.displayValue
            this.isChanged = true
        },
        updateDefaultValue(newDefaultValue) {
            this._defaultValue = newDefaultValue
        }
    },
    directives: {
        onClickaway: VueClickaway.directive
    },
    created() {
        this._defaultValue = this.defaultValue
        EventBus.$on(`update-input-${this.name}`, this.updateValue)
        EventBus.$on(`update-default-value-${this.name}`, this.updateDefaultValue)
    },
    watch: {
        defaultValue(newValue, oldValue) {
            this._defaultValue = newValue
        }
    }
})

const InlineDateComponent = InlineEditComponent.extend({
    data() {
        return {
            datePickers: [],
            datepickerRerender: 0,
            datepickerValidation:
                [v => moment(new Date(v)).isValid() || 'Please, enter a data in the format YYYY-MM-DD'],
            exceptionList: ['date-picker']
        }
    },
    computed: {
        inputValue: {
            get() {
                if (this.isChanged) {
                    return this.displayValue
                }
                return this._defaultValue
            },
            set(newValue) {
                let date = moment(new Date(newValue))
                if(!date.isValid()){
                    return
                }

                this.isChanged = true
                this.displayValue = date.format("YYYY-MM-DD")
            }
        }
    },
    methods: {
        emitUpdate() {
            if (this.emitUpdateEvent) {
                EventBus.$emit('input-updated', {'name': this.name, 'value': this.inputValue})
            }
        }
    }
})

Vue.component('inline-edit-date-component', InlineDateComponent)

const InlineDropdownComponent = InlineEditComponent.extend({
    data() {
        return {
            selectedValue: null,
            displayValue: null,
            exceptionList: ['select-dropdown']
        }
    },
    props: {
        choices: {
            type: Array,
            required: true
        },
        displayDefaultValue: {
            type: String,
            required: true
        }
    },
    computed: {
        inputValue: {
            get() {
                if (this.isChanged) {
                    return this.selectedValue
                }

                return this._defaultValue
            },
            set(newValue) {
                this.isChanged = true
                let choice = this.getChoice(newValue)
                this.displayValue = choice && choice.text
                this.selectedValue = newValue
                if (this.emitUpdateEvent) {
                    EventBus.$emit('input-updated', {'name': this.name, 'value': newValue})
                }
            }
        }
    },
    methods: {
        getChoice(value) {
            return this.choices.find(choice => choice.value === value)
        },
        updateValue(params) {
            let selectedValue = params.newValue
            if (selectedValue !== "") {
                selectedValue = params.newValue || this.selectedValue
            }
            this.isChanged = true
            let choice = this.getChoice(selectedValue)
            this.displayValue = choice && choice.text
            this.selectedValue = selectedValue
        }
    },
    created() {
        let choice = this.getChoice(this.displayDefaultValue)
        this.displayValue = choice && choice.text
    }
})

Vue.component('inline-edit-dropdown-component', InlineDropdownComponent)

const InlineTimeComponent = InlineEditComponent.extend({
    data() {
        return {
            timePickers: [],
            timepickerRerender: 0,
            timepickerValidation:
                [v => moment(v, 'HH:mm', true).isValid() || 'Please, enter a time between 07:00 and 18:00'],
            exceptionList: ['time-picker'],
            minutesChoices: [0, 15, 30, 45],
            hoursChoices: [7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18]
        }
    },
    computed: {
        inputValue: {
            get() {
                if (this.isChanged) {
                    return this.displayValue
                }
                return this._defaultValue
            },
            set(newValue) {
                let time = moment(newValue, 'HH:mm', true)
                if(!time.isValid()){
                    return
                }
                this.isChanged = true
                this.displayValue = newValue
            }
        }
    },
    methods: {
        emitUpdate() {
            if (this.emitUpdateEvent) {
                EventBus.$emit('input-updated', {'name': this.name, 'value': this.inputValue})
            }
        },
    },
})

Vue.component('inline-edit-time-component', InlineTimeComponent)

function getUrlParameterByName(name) {
    let url = window.location.href
    name = name.replace(/[\[\]]/g, '\\$&');
    let regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)')
    let results = regex.exec(url)
    if (!results) return null
    if (!results[2]) return ''
    return decodeURIComponent(results[2].replace(/\+/g, ' '))
}

function insertUrlSearchParam(key, value) {
    key = encodeURIComponent(key)
    value = encodeURIComponent(value)

    let kvp = document.location.search.substr(1).split('&').filter(x => x)

    for (let i = 0; i < kvp.length; i++) {
        if (kvp[i].startsWith(key + '=')) {
            let pair = kvp[i].split('=')
            pair[1] = value
            kvp[i] = pair.join('=')
            break;
        }
    }
    if (kvp.length === 0) {
        kvp[0] = [key, value].join('=');
    }

    return '?' + kvp.join('&')
}

